/* ===========================================================================
   ppz-sessioni.js — cosa fanno i visitatori sul sito        (v1.1, 16/10/2026)
   v1.1: keepalive al massimo 32 KB in volo (meta' dei 64 KB del browser): all'uscita
   l'ultimo pezzo della registrazione non toglie piu' posto ai beacon di Meta e Shopify.

   COSA FA
   Manda al Worker «ppz-sessioni» (Cloudflare, separato dal ponte di Meta):
   - gli EVENTI della visita: pagina, sezioni viste e per quanto, offerta in
     vista, clic (con il punto nella pagina), clic di rabbia, scorrimento,
     carrello, cassa, FAQ, video, recensioni, errori, uscita. A lotti piccoli
     (text/plain, <= 60 KB) ogni ~8 secondi e quando si esce dalla pagina;
   - la REGISTRAZIONE della visita (rrweb, file ppz-rrweb-record.min.js),
     caricata solo dopo il primo tocco o dopo 3 secondi, e solo per la quota
     di sessioni scelta nelle impostazioni del tema («PurePet — Sessioni»).

   COSA NON ESCE MAI
   - Il testo scritto nei campi: nella registrazione tutti i campi sono
     mascherati (maskAllInputs); negli eventi non si legge mai un campo scritto
     a mano (del modulo del carrello si leggono solo variante, quantita' e
     piano, che sono numeri), e il testo di un clic non viene mai da un campo.
   - L'IP: il Worker tiene solo il paese. Il cookie _fbp va al Worker, che lo
     trasforma subito in un'impronta. Gli indirizzi perdono la query (restano
     solo gli utm e «fbclid=1»), anche nella registrazione.

   CHI NON VIENE REGISTRATO
   - l'editor del tema (Shopify.designMode) e i temi non pubblicati;
   - robot e browser automatici (navigator.webdriver);
   - chi apre una volta il sito con ?ppz_interno=1 (Simone, Edoardo, prove):
     cookie di un anno; ?ppz_interno=0 lo toglie.
   Consenso: Simone ha scelto di registrare tutti (15/10/2026), il banner dei
   cookie resta com'e'. Lo stato del consenso di Shopify va comunque nel lotto.

   COME SI LEGA AL RESTO
   - ppz_sid (cookie di 30 minuti di inattivita' + sessionStorage) = la
     sessione. Lo legge anche il pixel «PurePet Sessioni» in cassa: i passi
     della cassa e l'ordine finiscono nella stessa sessione.
   - ppz_uid = il visitatore: lo crea il pixel Meta, qui si legge e basta.
   - pv = una pagina vista; ogni evento ha la chiave «pv:n».

   CONVIVENZA COL TEMA
   Ascoltatori delegati sul documento, in cattura e passivi: mai
   preventDefault ne' stopPropagation. Non si avvolgono fetch e XHR (lo fa
   gia' ppz-meta.js): qui si usa la fetch originale, presa prima. Ogni
   ascoltatore e' dentro un try/catch: un errore di questo file non tocca la
   pagina. Stato per i controlli, dalla console: window.ppzSessioni.stato
   (motivo = perche' e' fermo; replay = spento, escluso, attesa, acceso,
   non caricato, errore, troppo grande).
   =========================================================================== */
(function () {
  'use strict';

  var W = window;
  var D = document;
  var L = location;
  var M = Math;
  var C = W.ppzSessioni && typeof W.ppzSessioni === 'object' ? W.ppzSessioni : {};
  if (C.stato) return; // file incluso due volte
  var stato = (C.stato = { attivo: false, motivo: '', replay: 'spento', eventi: 0, lotti: 0, pezzi: 0 });

  var BASE = String(C.url || '').replace(/\/+$/, '');
  var QUOTA = +C.replay || 0; // percentuale di sessioni con la registrazione (0-100)
  var MAX_LOTTO = 60000; // il Worker scarta i lotti piu' grandi; keepalive regge 64 KB in volo
  var MAX_PEZZO = 1048576; // il Worker scarta i pezzi piu' grandi
  var KEEP_MAX = 32000; // keepalive in volo: il browser ne regge 64 KB per pagina, la meta' resta a Meta e Shopify
  var MEZZORA = 1800000;
  var RE_SID = /^[\w-]{16,64}$/; // [A-Za-z0-9_-]
  var RE_UID = /^[a-z0-9-]{16,64}$/i; // la stessa del pixel Meta v13
  var RE_FB = /^fb\.\d\.\d{10,13}\.[\w-]{1,500}$/; // _fbp e _fbc
  /* Robot che eseguono JavaScript (Googlebot, AdsBot-Google, bingbot, Applebot, Lighthouse, WebPageTest...). */
  var ROBOT = /bot[\/;-]|crawl|spider|headless|lighthouse|ptst|gtmetrix|pingdom|inspectiontool/i;
  var AZIONABILE = 'a,button,summary,label,select,input,textarea,[role=button],[data-ppz-bundle],[data-ppz-card],[tabindex]';
  /* Bottoni della cassa: quello del carrello PurePet, il modulo del carrello, i link, i pagamenti rapidi di Horizon. */
  var CASSA = '.ppz-cart__checkout,[name=checkout],[href*="/checkout"],shopify-accelerated-checkout,shopify-accelerated-checkout-cart';
  var SOGLIE = [25, 50, 75, 90, 100];
  /* La fetch del browser presa PRIMA di ppz-meta.js (che la avvolge per il carrello): i nostri invii non passano di li'. */
  var spedisci = W.fetch && W.fetch.bind(W);

  function protetto(f) {
    return function (e) {
      try {
        f(e);
      } catch (x) {
        /* mai un errore verso la pagina */
      }
    };
  }
  function adesso() {
    return Date.now();
  }

  /* --- cookie, memoria, testi ------------------------------------------------ */

  function leggiCookie(nome) {
    var parti = ('; ' + D.cookie).split('; ' + nome + '=');
    return parti.length > 1 ? parti.pop().split(';')[0] : '';
  }
  /* Senza dominio, come ppz_uid del pixel Meta: lo legge anche il pixel della cassa (stesso host). */
  function scriviCookie(nome, valore, secondi) {
    D.cookie = nome + '=' + valore + '; path=/; max-age=' + secondi + '; SameSite=Lax';
  }
  /* n caratteri casuali [0-9a-z] dal generatore crittografico (22 caratteri = 113 bit). */
  function casuale(n) {
    var a = W.crypto.getRandomValues(new Uint8Array(n));
    var s = '';
    for (var i = 0; i < n; i++) s += (a[i] % 36).toString(36);
    return s;
  }
  function memoria(m) {
    try {
      if (m) W.sessionStorage.setItem('ppz_sid', JSON.stringify(m));
      else return JSON.parse(W.sessionStorage.getItem('ppz_sid')) || {};
    } catch (e) {
      /* navigazione privata o memoria piena: resta il cookie */
    }
    return {};
  }
  /* Testi che escono dalla pagina: spazi compressi, niente email ne' numeri lunghi (telefoni, ordini). */
  function pulito(s, max) {
    return String(s || '')
      .replace(/[^\s@'"<>]+@[^\s@'"<>]+/g, '[email]')
      .replace(/\d[\d .-]{6,}\d/g, '[n]')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  }
  function sotto(s, limite) {
    return s.length * 3 <= limite || new Blob([s]).size <= limite;
  }
  /* Query senza dati: restano gli utm (l'inserzione) e la presenza di fbclid, mai il suo valore. */
  function queryPulita() {
    var q = new URLSearchParams(L.search);
    var fuori = [];
    'source medium campaign content term'.split(' ').forEach(function (k) {
      var v = q.get('utm_' + k);
      if (v) fuori.push('utm_' + k + '=' + encodeURIComponent(v.slice(0, 100)));
    });
    if (q.has('fbclid')) fuori.push('fbclid=1');
    return fuori.length ? '?' + fuori.join('&') : '';
  }
  function indirizzoPulito() {
    return L.origin + L.pathname + queryPulita();
  }
  /* rrweb rende assoluti i link interni della pagina («#sezione» diventa l'indirizzo intero, query compresa): nella
     registrazione la query della pagina diventa quella pulita, e i valori lunghi (fbclid, gclid, token, email) spariscono
     ovunque siano finiti. Gli utm restano. */
  function ripulisci(s) {
    var q = L.search;
    if (q.length > 1) {
      s = s.split(q).join(queryPulita());
      new URLSearchParams(q).forEach(function (v, k) {
        if (v.length > 15 && k.indexOf('utm_')) s = s.split(v).join('x');
      });
    }
    return s;
  }
  /* Lo stato del consenso di Shopify, se l'API c'e': «analytics,marketing,preferences,sale_of_data». */
  function consenso() {
    try {
      var v = W.Shopify.customerPrivacy.currentVisitorConsent();
      return (
        Object.keys(v)
          .filter(function (k) {
            return v[k] === 'yes';
          })
          .join(',') || 'nessuno'
      );
    } catch (e) {
      return undefined;
    }
  }

  /* --- chi non si registra ------------------------------------------------- */

  function motivoPerFermarsi() {
    var S = W.Shopify || {};
    var q = L.search;
    if (!BASE) return 'indirizzo';
    if (S.designMode) return 'editor';
    if (!S.theme || S.theme.role !== 'main') return 'non pubblicato';
    if (navigator.webdriver || ROBOT.test(navigator.userAgent)) return 'robot';
    if (/[?&]ppz_interno=1/.test(q)) scriviCookie('ppz_interno', '1', 31536000);
    if (/[?&]ppz_interno=0/.test(q)) scriviCookie('ppz_interno', '', 0);
    else if (leggiCookie('ppz_interno') === '1') return 'interno';
    return ''; // un browser troppo vecchio si ferma da solo nel try/catch di avvia (motivo «errore»)
  }

  /* --- sessione -------------------------------------------------------------
     Vive nel cookie ppz_sid (30 minuti, rinnovato con l'attivita' al massimo
     una volta al minuto) e nella sessionStorage della scheda. Sessione nuova
     dopo mezz'ora ferma, o arrivando da un'inserzione diversa (utm). */
  var sess = null; // { sid, r: registrazione 0/1, c: firma della campagna }
  var inizio = null; // arrivo: va nei lotti della pagina dove la sessione e' nata
  var ultimaAttivita = 0;
  var ultimoRinnovo = 0;

  function apriSessione() {
    var ora = adesso();
    var m = memoria();
    var sid = leggiCookie('ppz_sid');
    var q = new URLSearchParams(L.search);
    var firma = q.get('utm_content') || q.get('utm_campaign') || ''; // l'inserzione (utm_content = id dell'ads)
    if (!RE_SID.test(sid)) sid = RE_SID.test(m.sid) && ora - m.t < MEZZORA ? m.sid : '';
    var stessa = sid && m.sid === sid;
    if (!sid || (firma && stessa && m.c !== firma)) {
      sid = casuale(22);
      stessa = false;
      var ref = '';
      try {
        ref = new URL(D.referrer).origin; // solo il sito di provenienza, mai la pagina
      } catch (e) {
        /* nessuna provenienza */
      }
      inizio = { url: indirizzoPulito(), ref: ref, w: W.innerWidth };
    }
    sess = { sid: sid, r: stessa && m.r >= 0 ? m.r : M.random() * 100 < QUOTA ? 1 : 0, c: firma || (stessa && m.c) || '' };
    ultimaAttivita = ora;
    rinnova(ora);
  }
  function rinnova(ora) {
    ultimoRinnovo = ora;
    scriviCookie('ppz_sid', sess.sid, 1800);
    memoria(Object.assign({ t: ora }, sess));
  }
  /* Attivita' vera del visitatore (clic, scorrimento, ritorno sulla scheda). */
  function tocca() {
    var ora = adesso();
    if (ora - ultimaAttivita > MEZZORA) return nuovaVista(); // pagina ferma da mezz'ora: sessione e vista nuove
    ultimaAttivita = ora;
    if (ora - ultimoRinnovo > 60000) rinnova(ora);
  }

  /* --- eventi e lotti --------------------------------------------------------
     Evento = { k: «pv:n», t: ora, tipo, d: dati }. La pagina la dice il lotto (url): una per documento. */

  var coda = [];
  var pv = '';
  var n = 0;

  function evento(tipo, d) {
    coda.push({ k: pv + ':' + ++n, t: adesso(), tipo: tipo, d: d });
    stato.eventi++;
    if (coda.length > 149) svuota();
  }
  function corpoLotto(ev) {
    var l = { v: 1, src: 'tema', sid: sess.sid, url: L.origin + L.pathname, consenso: consenso() };
    var u = leggiCookie('ppz_uid');
    var f = leggiCookie('_fbp');
    if (RE_UID.test(u)) l.uid = u;
    if (RE_FB.test(f)) l.fbp = f;
    if (inizio) {
      l.inizio = inizio;
      /* _fbc solo nella pagina d'arrivo e senza il clic: al Worker basta l'ora (fb.1.<ms>.) per dire «arrivato da
         un'inserzione in questa visita». */
      f = leggiCookie('_fbc');
      if (RE_FB.test(f)) l.fbc = f.split('.', 3).join('.') + '.';
    }
    l.ev = ev;
    return JSON.stringify(l);
  }
  function svuota() {
    while (coda.length) {
      var ev = coda.splice(0, 150);
      var corpo = corpoLotto(ev);
      while (!sotto(corpo, MAX_LOTTO) && ev.length > 1) {
        coda = ev.splice(ev.length >> 1).concat(coda); // troppo grande: meta' torna in coda
        corpo = corpoLotto(ev);
      }
      if (sotto(corpo, MAX_LOTTO)) {
        manda(BASE + '/v', corpo, true);
        stato.lotti++;
      }
    }
  }
  /* no-cors e corpo testo (o byte): richiesta semplice, niente preflight, niente cookie verso il Worker.
     keepalive: arriva anche se la pagina si chiude. */
  var inVolo = 0; // byte keepalive partiti e non ancora arrivati
  function manda(url, corpo, keep) {
    var n = 0;
    if (keep) {
      n = typeof corpo === 'string' ? new Blob([corpo]).size : corpo.byteLength;
      if (inVolo + n > KEEP_MAX) keep = false, n = 0; // senza keepalive: puo' perdersi se la pagina si chiude, ma non ruba posto
      inVolo += n;
    }
    spedisci(url, { method: 'POST', mode: 'no-cors', keepalive: keep, body: corpo })
      .catch(function () {
        /* rete assente: niente da fare */
      })
      .then(function () {
        inVolo -= n;
      });
  }

  /* --- pagina: chi scorre, sezioni, offerta ----------------------------------- */

  var involucro = null; // .page-wrapper: da 990 px in su scorre lui, non la finestra (base.css r.28-51)
  function radice() {
    return D.scrollingElement || D.documentElement;
  }
  function scorritore() {
    var o = involucro && involucro.scrollHeight > involucro.clientHeight + 1 && W.getComputedStyle(involucro).overflowY;
    return o === 'auto' || o === 'scroll' ? involucro : radice();
  }
  /* Chiave della sezione: la parte dopo «__» dell'id del wrapper (lp_offer, adv_hero, ppz_footer). */
  function chiave(el) {
    var id = el.id;
    var i = id.lastIndexOf('__');
    return i < 0 ? id.replace('shopify-section-', '') : id.slice(i + 2); // il Worker la accorcia a 60
  }
  function sezioneDi(el) {
    var s = el.closest('.shopify-section');
    return s ? chiave(s) : undefined;
  }

  var sezioni = [];
  var osservatore = null;
  var offerte = {};
  var ultima = '';
  var nascosta = false;
  var carrelloAperto = false;
  var pausa = false;

  /* Le sezioni della pagina, in ordine. Fuori il cassetto del carrello (sta sopra la pagina) e la testata (sempre
     in vista). o = l'offerta dentro la sezione (landing: [data-ppz-offer]; scheda: [data-ppz-buy]). */
  function preparaSezioni() {
    var tutte = D.querySelectorAll('.shopify-section');
    var mappa = new Map();
    for (var i = 0; i < tutte.length; i++) {
      var el = tutte[i];
      if (el.id === 'shopify-section-ppz-cart-drawer' || el.closest('#header-group')) continue;
      /* vic = vicina allo schermo (osservatore), vis = vista adesso, h = px visibili, da = da quando conta */
      var s = { el: el, id: chiave(el), o: el.querySelector('[data-ppz-offer],[data-ppz-buy]') };
      sezioni.push(s);
      mappa.set(el, s);
    }
    /* L'osservatore dice solo chi e' vicino allo schermo; quanto si vede lo misura valuta() (anche per le sezioni
       piu' alte dello schermo, come l'offerta, che non arrivano mai al 50%). */
    osservatore = new IntersectionObserver(
        protetto(function (voci) {
          voci.forEach(function (v) {
            mappa.get(v.target).vic = v.isIntersecting;
          });
          valuta();
        }),
        { threshold: [0, 0.5, 1] }
      );
  }
  function visibileDi(el, h) {
    var r = el.getBoundingClientRect();
    var v = M.max(0, M.min(r.bottom, h) - M.max(r.top, 0));
    return r.height >= 40 && (v >= 0.5 * r.height || v >= 0.4 * h) ? v : 0;
  }
  /* Sezione «vista»: almeno meta' visibile, oppure copre almeno il 40% dello schermo. Offerta: la stessa regola. */
  function valuta() {
    var h = W.innerHeight || 1;
    sezioni.forEach(function (s) {
      s.h = s.vic ? visibileDi(s.el, h) : 0;
      if (s.h && !s.vis) {
        s.vis = true;
        ultima = s.id;
        parti(s);
      } else if (!s.h && s.vis) {
        s.vis = false;
        ferma(s);
      }
      if (s.h && s.o && !offerte[s.id] && visibileDi(s.o, h)) {
        offerte[s.id] = 1;
        evento('offerta', { id: s.id, ms: adesso() - inizioVista });
      }
    });
  }
  /* Permanenza: conta solo a scheda visibile e a carrello chiuso. Un evento per ogni tratto di almeno 1 secondo. */
  function parti(s) {
    if (!pausa) s.da = adesso();
  }
  function ferma(s) {
    var ms = s.da && adesso() - s.da;
    s.da = 0;
    if (ms >= 1000) evento('sezione', { id: s.id, ms: ms });
  }
  function aggiornaPausa() {
    var p = nascosta || carrelloAperto;
    if (p === pausa) return;
    pausa = p;
    sezioni.forEach(function (s) {
      if (s.vis) p ? ferma(s) : parti(s);
    });
  }

  /* --- scorrimento ------------------------------------------------------------ */

  var maxScroll = 0;
  var soglia = 0;
  var scrollTimer = 0;

  function alloScroll(e) {
    var t = e.target;
    if (t !== D && t !== D.body && t !== involucro) return; // caroselli e pannelli interni: non sono la pagina
    scrollTimer =
      scrollTimer ||
      setTimeout(
        protetto(function () {
          scrollTimer = 0;
          misuraScroll(scorritore());
          valuta();
          tocca();
        }),
        200
      );
  }
  /* Profondita' = fondo dello schermo / altezza della pagina (di chi scorre: finestra o .page-wrapper). */
  function misuraScroll(el) {
    var p = M.min(100, M.round(((el.scrollTop + el.clientHeight) / el.scrollHeight) * 100));
    if (p > maxScroll) maxScroll = p;
    while (maxScroll >= SOGLIE[soglia]) evento('scroll', { max: SOGLIE[soglia++] });
  }

  /* --- clic ----------------------------------------------------------------- */

  var ultimoClic = null;
  var raffica = null;
  var rafficaTimer = 0;

  /* Selettore corto e stabile: id leggibile, poi un attributo data-ppz-*, poi una classe (prima le ppz-), se no il
     genitore. Mai il percorso intero. */
  function selettore(el, su) {
    var tag = el.tagName.toLowerCase();
    var id = el.id;
    var g = gancio(el, 1);
    var cl = ' ' + (el.getAttribute('class') || '') + ' ';
    var c = /\s(ppz-[\w-]{1,50})\s/.exec(cl) || /\s([A-Za-z][\w-]{1,40})\s/.exec(cl);
    var p = el.parentElement;
    return /^[A-Za-z][\w-]{0,39}$/.test(id) && !/\d{5}/.test(id)
      ? tag + '#' + id
      : g
        ? tag + '[data-' + g.replace(/=(.*)/, '="$1"') + ']'
        : c
          ? tag + '.' + c[1]
          : !su && p && p !== D.body
            ? selettore(p, 1) + '>' + tag
            : tag;
  }
  /* Primo attributo data-ppz-* dell'elemento (o dei suoi genitori fino a `quanti`): dice «cosa» e' stato toccato. */
  function gancio(el, quanti) {
    for (var x = el, k = 0; x && x.attributes && k < quanti; x = x.parentElement, k++) {
      for (var i = 0; i < x.attributes.length; i++) {
        var a = x.attributes[i];
        if (!a.name.indexOf('data-ppz-')) return (a.name.slice(5) + (/^[\w-]{1,16}$/.test(a.value) ? '=' + a.value : '')).slice(0, 40);
      }
    }
    return '';
  }
  function alClic(e) {
    if (!e.isTrusted) return; // i clic finti degli script del tema non sono del visitatore
    var t = e.target.nodeType === 1 ? e.target : e.target.parentElement;
    tocca();
    var el = t.closest(AZIONABILE) || t;
    var id = sezioneDi(el);
    var g = gancio(el, 4);
    var x = e.clientX;
    var y = e.clientY;
    /* Testo di quello che si tocca (max 60). MAI da un campo; da un contenitore grande nemmeno (non vuol dire niente). */
    var testo = el.closest('input,textarea,select,[contenteditable]')
      ? ''
      : pulito(el.getAttribute('aria-label') || (el.getElementsByTagName('*').length < 41 && (el.textContent || el.getAttribute('alt'))), 60);
    /* x in millesimi della larghezza della pagina, y in px dall'alto della pagina (anche quando scorre .page-wrapper). */
    var sc = scorritore();
    var r = sc.getBoundingClientRect(); // per la finestra: il documento, che sale mentre si scorre
    if (!e.detail && !x && !y) {
      var b = el.getBoundingClientRect(); // clic da tastiera: il centro dell'elemento
      x = b.left + b.width / 2;
      y = b.top + b.height / 2;
    }
    var d = {
      sel: selettore(el), // corto per costruzione (il Worker lo taglia comunque a 160)
      testo: testo,
      x: M.round(((x - r.left) / sc.clientWidth) * 1000),
      y: M.round(y - r.top + (sc === radice() ? 0 : sc.scrollTop)),
      w: W.innerWidth,
      hook: g,
      id: id
    };
    ultimoClic = { t: adesso(), d: d };
    evento('click', d);
    rabbia(e, d);

    if (el.closest(CASSA)) evento('cassa');
    /* Piu'/meno/cestino del carrello: data-ppz-cart-set = i pezzi che la riga avra'. */
    var qta = parseInt(g.split('ppz-cart-set=')[1], 10);
    if (qta >= 0) evento('carrello', { azione: qta ? 'cambia' : 'rimuovi', qta: qta });
    /* Recensioni: filtro stelle (N), altre, apri il modulo, dettagli. Frecce e pallini dei caroselli restano clic
       (gancio ppz-prev / ppz-next / ppz-dot, con la sezione). */
    var rv = /^ppz-rv-([a-z-]+)=?(\d*)/.exec(g);
    if (rv) evento('recensioni', { id: id, azione: rv[1], n: rv[2] ? +rv[2] : undefined });
  }

  /* Rabbia: 3 o piu' clic entro 1 secondo, a meno di 30 px dal primo. Un evento per raffica, a raffica finita, con
     quanti clic (n). */
  function rabbia(e, d) {
    var ora = adesso();
    var r = raffica;
    if (r && ora - r.t < 1000 && M.abs(e.clientX - r.x) <= 30 && M.abs(e.clientY - r.y) <= 30) {
      if (++r.d.n === 3) r.ok = ora - r.t0 <= 1000;
    } else {
      chiudiRaffica();
      r = raffica = { t0: ora, x: e.clientX, y: e.clientY, d: Object.assign({ n: 1 }, d) }; // i dati del primo clic
    }
    r.t = ora;
    clearTimeout(rafficaTimer);
    rafficaTimer = setTimeout(protetto(chiudiRaffica), 1000);
  }
  function chiudiRaffica() {
    if (raffica && raffica.ok) evento('rabbia', raffica.d);
    raffica = null;
  }

  /* --- carrello, FAQ, video, errori -------------------------------------------- */

  /* Solo numeri dal modulo del carrello (variante, quantita', piano): mai un campo scritto a mano. */
  function numeroDi(f, nome) {
    var c = f.querySelector('[name="' + nome + '"]');
    var v = c && !c.disabled && c.value;
    return /^\d{1,20}$/.test(v) ? v : undefined;
  }
  function alSubmit(e) {
    var f = e.target;
    if (/\/cart\/add/.test(f.getAttribute('action'))) {
      /* Si legge appena dopo: ppz-offer.js e ppz-buybox.js sistemano il piano proprio nel submit. */
      setTimeout(
        protetto(function () {
          evento('carrello', { azione: 'aggiungi', qta: +numeroDi(f, 'quantity') || 1, variante: numeroDi(f, 'id'), piano: numeroDi(f, 'selling_plan') });
        })
      );
    } else if (f.id === 'ppz-recensione') evento('recensioni', { id: sezioneDi(f), azione: 'inviata' });
  }
  /* ppz-buybox.js annuncia la confezione scelta (ppz:bundle, detail.units): si scrive sul clic che l'ha scelta. */
  function alBundle(e) {
    var u = e.detail && +e.detail.units;
    if (u > 0 && ultimoClic && adesso() - ultimoClic.t < 1000) ultimoClic.d.hook = 'ppz-bundle=' + u;
  }
  function preparaCarrello() {
    var c = D.getElementById('ppz-cart');
    if (c) {
      new MutationObserver(
        protetto(function () {
          var aperto = c.hasAttribute('data-open');
          if (aperto === carrelloAperto) return;
          carrelloAperto = aperto;
          evento('carrello', { azione: aperto ? 'apri' : 'chiudi' });
          aggiornaPausa();
        })
      ).observe(c, { attributes: true, attributeFilter: ['data-open'] });
    }
  }
  function alToggle(e) {
    var t = e.target;
    if (t.tagName === 'DETAILS' && t.open) {
      var q = t.querySelector('summary');
      evento('faq', { id: sezioneDi(t), testo: pulito(q && q.textContent, 80), azione: 'apri' });
    }
  }
  /* Video: il primo play, le pause dopo almeno 1 s di visione, la fine. I video di sfondo (muti e automatici) no. */
  var video = null;
  function alVideo(e) {
    var v = e.target;
    if (v.tagName !== 'VIDEO' || (v.autoplay && v.muted)) return;
    var i = video.get(v) || {};
    var ms = M.round(v.currentTime * 1000) || 0;
    var az = { play: 'play', pause: 'pausa', ended: 'fine' }[e.type];
    if (az === 'play' ? i.az : !i.az || i.az === 'fine' || (az === 'pausa' && ms < i.ms + 1000)) return;
    video.set(v, { az: az, ms: ms });
    evento('video', { id: sezioneDi(v), azione: az, ms: ms });
  }
  var errori = 0;
  /* Errori della pagina (anche non nostri): messaggio e file senza query, al massimo 10 per pagina. */
  function errore(msg, file, riga) {
    if (errori++ < 10) {
      evento('errore', {
        msg: pulito(String(msg).replace(/(https?:\/\/[^\s?#'"]+)[?#][^\s'"]*/g, '$1'), 160),
        file: String(file || '').split(/[?#]/)[0], // il Worker lo accorcia a 160
        riga: riga
      });
    }
  }
  function alErrore(e) {
    if (e.message) errore(e.message, e.filename, e.lineno); // risorse che non si caricano: niente messaggio, non contano
  }
  function alRifiuto(e) {
    var r = e.reason;
    errore('promessa: ' + (r && typeof r === 'object' ? r.message || r.name : r));
  }

  /* --- uscita e ritorno ---------------------------------------------------------- */

  var inizioVista = 0;
  var attivoMs = 0;
  var attivoDa = 0;
  var uscitaFatta = false;

  function esci() {
    if (uscitaFatta) return;
    uscitaFatta = nascosta = true;
    attivoMs += attivoDa && adesso() - attivoDa;
    attivoDa = 0;
    aggiornaPausa(); // chiude le permanenze aperte
    chiudiRaffica();
    var corrente = null; // la sezione piu' in vista quando se ne va
    sezioni.forEach(function (s) {
      if (s.vis && (!corrente || s.h > corrente.h)) corrente = s;
    });
    evento('uscita', { ms: attivoMs, max: maxScroll, id: corrente ? corrente.id : ultima || undefined });
    svuota();
    if (rr) mandaPezzo(rr, true);
  }
  function alCambioVista() {
    if (D.visibilityState === 'hidden') return esci();
    if (adesso() - ultimaAttivita > MEZZORA) return nuovaVista(); // tornato dopo piu' di mezz'ora: sessione nuova
    nascosta = uscitaFatta = false;
    attivoDa = adesso();
    aggiornaPausa();
    tocca();
  }

  /* --- registrazione (rrweb) -------------------------------------------------------- */

  var rr = null; // registrazione della vista: { sid, pv, buf, byte, n, ferma, timer, ko: fermata per un pezzo troppo grande }

  function preparaReplay() {
    if (!sess.r || !C.rec) return (stato.replay = 'spento');
    /* Pagine con dati della persona: niente registrazione (gli eventi si'). */
    if (/^\/(apps\/track123|account|challenge|password|search)/.test(L.pathname)) return (stato.replay = 'escluso');
    stato.replay = 'attesa';
    var nomi = ['pointerdown', 'keydown', 'scroll']; // pointerdown copre anche il dito (iOS 13+)
    var timer = setTimeout(via, 3000); // nessun tocco: si parte dopo 3 secondi, a pagina gia' disegnata
    var cattura = { capture: true, passive: true };
    function via() {
      clearTimeout(timer);
      nomi.forEach(function (x) {
        D.removeEventListener(x, via, cattura);
      });
      if (W.rrwebRecord) return registra();
      var s = D.createElement('script');
      s.src = C.rec;
      s.onload = protetto(registra);
      s.onerror = function () {
        stato.replay = 'non caricato';
      };
      D.head.appendChild(s);
    }
    nomi.forEach(function (x) {
      D.addEventListener(x, via, cattura);
    });
  }
  function registra() {
    if (rr || !W.rrwebRecord) return;
    var mio = (rr = { sid: sess.sid, pv: pv, buf: [], byte: 0, n: 0 });
    var t0 = adesso();
    try {
      /* Restano i valori predefiniti di rrweb 2.1.6: niente canvas, niente font, niente immagini dentro, fogli di
         stile copiati (inlineStylesheet), cosi' la registrazione si rivede anche quando il tema cambia. */
      mio.ferma = W.rrwebRecord.record({
        emit: function (ev) {
          daRegistrare(mio, ev);
        },
        maskAllInputs: true,
        maskTextSelector: 'predictive-search-component,[data-ppz-privato]',
        /* Gli iframe (pixel di Shopify in sandbox, Shop Pay, chat) restano riquadri vuoti: dentro non c'e' niente
           da rivedere e Safari scriverebbe un errore in console a ogni sguardo di rrweb nel loro documento.
           keepIframeSrcFn vero quando l'indirizzo e' gia' stato tolto (riquadro): rrweb non ci guarda dentro. */
        blockSelector:
          '[data-ppz-countdown],[data-ppz-cart-timer],shopify-chat,#chat-drawer,[data-shopify-privacy=exclude],iframe',
        keepIframeSrcFn: function (s) {
          return !s;
        },
        slimDOMOptions: 'all',
        sampling: { mousemove: 100, scroll: 150, media: 800, input: 'last' },
        checkoutEveryNms: 300000,
        errorHandler: function () {
          return true; // gli errori interni del registratore non arrivano alla pagina
        }
      });
    } catch (e) {
      rr = null;
      return (stato.replay = 'errore');
    }
    /* Fotografia gia' troppo grande durante record() (senza compressione): ora che c'e' la maniglia si ferma. */
    if (mio.ko) return fermaRegistrazione(mio);
    stato.msFoto = adesso() - t0;
    stato.replay = 'acceso';
    mio.timer = setInterval(
      protetto(function () {
        mandaPezzo(mio);
      }),
      10000
    );
  }
  function daRegistrare(mio, ev) {
    if (mio.ko) return;
    /* L'indirizzo nella testata della registrazione perde la query (fbclid, eventuali dati). */
    if (ev.type === 4 && ev.data) ev.data.href = indirizzoPulito();
    var s = ripulisci(JSON.stringify(ev));
    mio.buf.push(s);
    mio.byte += s.length;
    /* La fotografia completa (tipo 2) parte subito: e' il pezzo 0, senza di lei la pagina non si rivede. */
    if (ev.type === 2 || mio.byte > 800000) mandaPezzo(mio);
  }
  function mandaPezzo(mio, uscita) {
    if (!mio.buf.length || mio.ko) return;
    var corpo = '[' + mio.buf.join(',') + ']';
    var url = BASE + '/r?s=' + mio.sid + '&p=' + mio.pv + '&n=' + mio.n++;
    mio.buf = [];
    mio.byte = 0;
    stato.pezzi++;
    /* All'uscita non si aspetta la compressione: se e' piccolo parte subito, in chiaro, con keepalive. */
    if (uscita && sotto(corpo, KEEP_MAX)) return manda(url + '&z=0', corpo, true);
    if (!W.CompressionStream) return sotto(corpo, MAX_PEZZO) ? manda(url + '&z=0', corpo) : troppoGrande(mio);
    new Response(new Blob([corpo]).stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer().then(
      protetto(function (b) {
        if (b.byteLength > MAX_PEZZO) return troppoGrande(mio);
        manda(url + '&z=1', b, uscita && b.byteLength < KEEP_MAX);
      })
    );
  }
  /* Un pezzo oltre 1 MB non si puo' mandare: la registrazione di questa pagina si ferma (gli eventi no). */
  function troppoGrande(mio) {
    mio.ko = 1;
    stato.replay = 'troppo grande';
    fermaRegistrazione(mio);
  }
  function fermaRegistrazione(mio) {
    clearInterval(mio.timer);
    if (mio.ferma) mio.ferma();
    if (rr === mio) rr = null;
  }

  /* --- vista di pagina ---------------------------------------------------------------- */

  function nuovaVista() {
    if (pv) {
      esci(); // la vista precedente si chiude (se non era gia' uscita)
      if (rr) fermaRegistrazione(rr);
    }
    inizio = null;
    apriSessione();
    pv = casuale(8);
    n = maxScroll = soglia = errori = attivoMs = 0;
    nascosta = D.visibilityState === 'hidden';
    uscitaFatta = false;
    inizioVista = adesso();
    attivoDa = nascosta ? 0 : inizioVista;
    ultima = '';
    offerte = {};
    raffica = null;
    video = new WeakMap();
    aggiornaPausa();
    stato.sid = sess.sid;
    stato.pv = pv;
    var main = D.getElementById('MainContent');
    var sc = scorritore();
    evento('pagina', {
      modello: main && main.getAttribute('data-template'),
      sezioni: sezioni.map(function (s) {
        return s.id;
      }),
      dw: sc.clientWidth,
      dh: sc.scrollHeight,
      titolo: pulito(D.title, 120)
    });
    /* Si riparte da zero: observe() rimanda subito lo stato di ogni sezione. */
    osservatore.disconnect();
    sezioni.forEach(function (s) {
      s.vic = s.vis = false;
      s.da = s.h = 0;
      osservatore.observe(s.el);
    });
    misuraScroll(sc);
    preparaReplay();
  }

  /* Ogni ~8 s: le permanenze lunghe partono a pezzi (nel browser di Instagram l'uscita spesso non arriva), poi il lotto. */
  function ciclo() {
    var ora = adesso();
    if (!nascosta) {
      sezioni.forEach(function (s) {
        if (s.vis && s.da && ora - s.da > 15000) {
          ferma(s);
          parti(s);
        }
      });
    }
    svuota();
  }

  function avvia() {
    stato.motivo = motivoPerFermarsi();
    if (stato.motivo) return;
    stato.attivo = true;
    involucro = D.querySelector('.page-wrapper');
    preparaSezioni();
    preparaCarrello();
    nuovaVista();
    var cattura = { capture: true, passive: true };
    var ascolta = function (dove, nomi, f) {
      nomi.split(' ').forEach(function (x) {
        dove.addEventListener(x, protetto(f), cattura);
      });
    };
    ascolta(D, 'click', alClic);
    ascolta(D, 'submit', alSubmit);
    ascolta(D, 'toggle', alToggle); // toggle, play/pause e scroll non risalgono: si prendono in cattura
    ascolta(D, 'play pause ended', alVideo);
    ascolta(D, 'scroll', alloScroll);
    ascolta(D, 'ppz:bundle', alBundle);
    ascolta(D, 'visibilitychange', alCambioVista);
    ascolta(W, 'pagehide', esci);
    ascolta(W, 'pageshow', function (e) {
      if (e.persisted) nuovaVista(); // ritorno dalla cache del browser (tasto indietro): vista nuova
    });
    ascolta(W, 'error', alErrore);
    ascolta(W, 'unhandledrejection', alRifiuto);
    ascolta(W, 'resize', valuta);
    setInterval(protetto(ciclo), 8000);
  }

  try {
    avvia();
  } catch (e) {
    stato.motivo = 'errore';
  }
})();
